import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Select from 'react-select';
import Footer from '../../../../_components/common/Footer';
import NavBar from '../../../../_components/common/Navbar';
import CustomTableNew from '../../../../_components/common/CustomTableNew'
import {CommonBreadCrumb} from '../../../../_components/common/CommonBreadCrumb'
import Page404 from '../../../404page';
import { organisationAction } from '../../../../_actions/organisation.action';
import { GroupReportAction } from '../../../../_actions/organisations/groupReport.action';
import { tables } from './CustomColumnTable'
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';

class GroupReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assessorSelectedOption: null,
            assessorDropdownOption: [],
            instrumentSelectedOption: null,
            instrumentDropdownOption: [],
            orgId: '',
            sellerId: 0,
            instrumentId: 0,
            assessorId: [],
            currentOrgData: [],
            checkBoxData: [],
            assessmentIds: [],
            groupReportModal: false,
            refreshState: false,
            reportDownloadDisabled: true,
            refreshedState:false,


            hasProperOrgId: true,
            idLoader: true
        }
    }

    componentDidMount() {
        const {dispatch} = this.props;

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");
        dispatch(organisationAction.getOrganisation(() => { }))

        dispatch(GroupReportAction.groupReportInstrumentList((resp_instrument_list) => {
            let instrumentDropdownOption = [];
            resp_instrument_list.data.data.map(val => {
                instrumentDropdownOption.push({
                    value: val.id,
                    label: val.instrument_name,
                    type: val.is_multi_rater
                });
            });
            this.setState({
                instrumentDropdownOption
            });
        }))

        this.setState({
            orgId: parseInt(orgIdFromPath, 10)
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.organisationList !== this.props.organisationList) {
            if (this.props.organisationList.length !== 0) {
                let currentOrgData = [];
                let assessorGroupList = [];
                let assessorDropdownOption = [];
                let sellerId = 0;
                let hasId = false;
                for (let i = 0; i < this.props.organisationList.length; i++) {
                    const element = this.props.organisationList[i];
                    if (element.id == this.state.orgId) {
                        hasId  = true
                        sellerId = element.seller__id
                        currentOrgData = element
                        
                    }
                }

                this.setState({
                    hasProperOrgId: hasId,
                    idLoader: false
                })

                assessorDropdownOption.push({
                    value: 0,
                    label: 'Self'
                })

              
                this.setState({
                    assessorDropdownOption,
                    currentOrgData,
                    sellerId,
                }, () => {
                    const { dispatch } = this.props;
                    const { orgId, sellerId } = this.state;

                    dispatch(organisationAction.getIntrumentList());

                })
            }
        }
    }

    chooseInstrument(data) {
        let assessorId = [...this.state.assessorId];
        let assessorSelectedOption = this.state.assessorSelectedOption;
        if(!data.type) {
            assessorId.splice(0, assessorId.length);
            assessorSelectedOption = null;
        };

        this.setState({
            instrumentSelectedOption: data,
            instrumentId: data.value,
            assessorId,
            assessorSelectedOption
        }, () => {
            const { dispatch } = this.props;
            this.selectAllBatch([], false)
          
            dispatch(GroupReportAction.groupReportList({
                    "seller_id":this.state.sellerId,
                    "organisation_id": this.state.orgId,
                    "instrument_id":this.state.instrumentId
                }))
        })
    }

    chooseAssessor(data) {
        let assessorId = [];
   
        data.map(val => {
            assessorId.push(val.value)
        })
        this.setState({
            assessorId,
            assessorSelectedOption: data
        }, () => {
            if(this.state.checkBoxData.length >= 2) {
             
                this.selectAllBatch(this.state.checkBoxData, true, 'assessor')
            }
        })
    }

    refreshToggle() {
        const { dispatch } = this.props;
        this.selectAllBatch([], false)
        if(this.state.instrumentId !== 0) {
            this.setState({
                refreshedState: true                
            }, () => {
                dispatch(GroupReportAction.groupReportList({
                        "seller_id":this.state.sellerId,
                        "organisation_id": this.state.orgId,
                        "instrument_id":this.state.instrumentId
                    }, (api_resp) => {
        
                        this.setState({
                            refreshedState: false
                        })
                    
                    }))
            })
        }else {
            this.setState({
                refreshedState: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        refreshedState: false
                    })
                }, 300);
            })
        }
    }

    selectAllBatch(data, clickToggle, type) {
       
   

        const { dispatch } = this.props;

        const assessment_ids = data.map(val => {
            return val.id
        })

      

        if(data.length >= 2 && type !== 'assessor') {
            dispatch(GroupReportAction.groupReportAssesorList({ assessment_ids }, (resp_assessor_data) => {
                let assessorDropdownOption = [];

                assessorDropdownOption.push({
                    value: 0,
                    label: 'Self'
                })


                resp_assessor_data.data.data.map(val => {
                    assessorDropdownOption.push({
                        value: val.assessor_group__id,
                        label: val.assessor_group__assessor_name
                    })
                })

                let validAssessorId = []

                
                for (let i = 0; i < resp_assessor_data.data.data.length; i++) {
                    const element = resp_assessor_data.data.data[i];                    
                    for (let j = 0; j < this.state.assessorId.length; j++) {
                        const elem = this.state.assessorId[j];
                        if(elem === element.assessor_group__id) {
                            validAssessorId.push({
                                value: element.assessor_group__id,
                                label: element.assessor_group__assessor_name
                            })
                            break;
                        }
                    }
                }

               

                for (let i = 0; i < this.state.assessorId.length; i++) {
                    const element = this.state.assessorId[i];
                    if(element === 0) {
                        validAssessorId.push({
                            value: 0,
                            label: 'Self'
                        })
                    }
                }

                const assessorId = validAssessorId.map(val => {
                    return val.value
                })
                
                
                this.setState({
                    reportDownloadDisabled: this.state.instrumentSelectedOption.type === false || validAssessorId.length ? false : true,
                    assessorId,
                    assessorSelectedOption: validAssessorId.length ? validAssessorId : null,
                    assessorDropdownOption
                })
            }))
        }

       
        
        if(clickToggle === true && data.length >= 2 && (this.state.instrumentId !== 0 && (this.state.assessorId.length !== 0 || this.state.instrumentSelectedOption.type === false))) {
            this.setState({
                reportDownloadDisabled: false
            })
        }else {
            this.setState({
                reportDownloadDisabled: true
            })
        }
    }

    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllBatch(this.state.checkBoxData, true)
                let assessmentIds = []
                this.state.checkBoxData.map(val => {
                    assessmentIds.push(val.id)
                })
                this.setState({
                    assessmentIds
                })
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllBatch(this.state.checkBoxData, false)
                let assessmentIds = []
                this.state.checkBoxData.map(val => {
                    assessmentIds.push(val.id)
                })
                this.setState({
                    assessmentIds
                })
            })
        }
    }

    groupReportModalToggle(data) {
      
        
    }

    render() {
        const {instrumentList, org_assessment_list} = this.props;
        const {currentOrgData} = this.state;
        return (
            <div 
                className="position-relative  custom-container"
                style={{minHeight: '100vh',display: 'grid', gridTemplateRows: 'auto 1fr auto'}}
            >
                <NavBar />
                {
                    this.state.idLoader ?
                        <div className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                    :
                        this.state.hasProperOrgId ? 
                            <div 
                                className="container" 
                                style={{ marginTop: 20, marginBottom: 20  }}
                            >
                                <CommonBreadCrumb 
                                    data={[
                                        {
                                            link: '/admin/app/dashboard',
                                            name: 'ADMIN'
                                        },{
                                            link: '/admin/app/organisation',
                                            name: 'ORGANISATION'
                                        },{
                                            link: `/admin/app/organisation/${this.state.orgId}`,
                                            name: 'ORGANISATION DETAILS'
                                        },{
                                            link: '',
                                            name: 'GROUP REPORT'
                                        }
                                    ]}
                                />
                                <div 
                                    style={{display: 'flex'}}
                                >
                                 
                                    <div style={{display: 'flex'}} className="w-50">
                                        <p>
                                            INSTRUMENT
                                            <span className="mandatory-star">*</span>
                                        </p>
                                        <Select
                                            className="w-50"
                                            value={this.state.instrumentSelectedOption}
                                            onChange={(data) => this.chooseInstrument(data)}
                                            options={this.state.instrumentDropdownOption}
                                        />
                                    </div>
                                    {
                                        this.state.instrumentSelectedOption !== null ?
                                            this.state.instrumentSelectedOption.type ?
                                                <div style={{display: 'flex'}} className="w-50">
                                                    <p>
                                                        ASSESSOR
                                                        <span className="mandatory-star">*</span>
                                                    </p>
                                                    <Select
                                                        className="w-50"
                                                        value={this.state.assessorSelectedOption}
                                                        onChange={(data) => this.chooseAssessor(data)}
                                                        options={this.state.assessorDropdownOption}
                                                        isMulti={true}
                                                    />
                                                </div>
                                            :
                                                <div className="w-50"></div>
                                        :
                                            <div className="w-50"></div>
                                    }
                                    
                                   
                                    <div>
                                        <button 
                                            className={!this.state.refreshedState ? "btn btn-red sm--size" : "btn btn-red sm--size disableButton" }
                                            type="button"
                                            style={{height: 30}} 
                                            onClick={() => this.refreshToggle()} 
                                        >
                                            REFRESH
                                        </button>
                                    </div>
                                </div>
                                    {
                                        !this.state.refreshedState &&
                                            <div>
                                                <div 
                                                    className="bg-green rounded-top mt-5 animation-fade-in"
                                                >
                                                    <p className="text-center text-uppercase py-2 text-white mb-0">ORGANISATION ASSESSMENTS</p>
                                                </div>
                                                <CustomSettingHead 
                                                    data={{
                                                        "seller_id":this.state.sellerId,
                                                        "organisation_id": this.state.orgId,
                                                        "instrument_id":this.state.instrumentId,
                                                        "assessor_goup_id":this.state.assessorId,
                                                        "assessment_ids":this.state.assessmentIds
                                                    }}
                                                    disabled={this.state.reportDownloadDisabled}
                                                />
                                                
                                                <CustomTableNew
                                                    data={org_assessment_list}
                                                    columns={tables.GroupReport}
                                                    checkboxData={this.state.checkBoxData}
                                                    showSlNo="false"
                                                    checkbox="true"
                                                    selectCheckBox={this.selectAllBatch.bind(this)}
                                                    getData={this.getSelectedData.bind(this)}
                                                    CheckKey={'id'}
                                                    refreshClear={this.state.refreshState}
                                                />
                                            </div>
                                    }
                            </div>
                        :
                            <Page404 />
                }
                <Footer />
            </div>
        )
    }
}

const CustomSettingHead = ({data, disabled}) => (
    <div className="bg-gray container animation-fade-in">
        <div className="row p-2">
            <div className=" col-md-12 pt-2 pb-2">
                <div className="row align-items-center" style={{height: "100%"}}>
                    <div className="col-2 col-md-1 col-lg-1" style={{width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <i className="fas fa-cog text-white"></i>
                    </div>
                    <div className="border-white border-left pr-0 col-9 col-md-9 col-lg-9" style={{borderTopLeftRadius: '2px', borderBottomLeftRadius: '2px'}}>
                        <Link onClick={
                                () => {
                                    localStorage.removeItem('download-obj');
                                    localStorage.setItem('download-obj', JSON.stringify({
                                        key: 'group',
                                        data: data
                                    }))
                                }
                            }
                            to={{ pathname: `/app/dashBoard/viewReport/0/Download` }}
                            target="_blank" 
                            className={disabled ? "btn btn-red btn-sm text-uppercase disabled" :  "btn btn-red btn-sm text-uppercase"}
                            style={{margin: '2px', fontSize: '10px', color: 'white'}}
                        >DOWNLOAD GROUP REPORT</Link>
                    </div>
                </div>
            </div>
            <div className="col-md-6 pt-2 pb-2"></div>
        </div>
    </div>
)

const SelectBox = ({name, list, onChange, keyData}) => (
    <div className="col-6" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <p>
            {name}
            <span className="mandatory-star">*</span>
        </p>
        <select 
            onChange={(e) => onChange(e)} 
            style={{ width: 250 }}
        >
            <option value={0} >Choose an Option...</option>
            {
                list.map(val => (
                    <option 
                        value={val[keyData.value]} 
                        key={val[keyData.key]}
                    >
                        {val[keyData.text]}
                    </option>
                ))
            }
        </select>
    </div>
)

const mapStateToProps = state => {

    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    const { instrument_full_error, instrument_full_loading } = state.instrumentListFull;
    const instrumentList = ( !instrument_full_error && !instrument_full_loading ) ? state.instrumentListFull.instrument_full_list.instrument_list : [];

    const {org_assessment_list_error, org_assessment_list_loading} = state.groupReportOrganisationAsessment
    const org_assessment_list = (!org_assessment_list_error && !org_assessment_list_loading) ? state.groupReportOrganisationAsessment.org_assessment_list.data.data : '';

    return {
        organisationList,
        instrumentList,
        
        org_assessment_list
    }
}

export default connect(mapStateToProps)(GroupReport)


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/groupReport.jsx